import { SellerFiscalDataUi } from '@/components/Seller/SellerProfile/FiscalData/SellerFiscalDataUi';
import {
  CfdiUsesResponse,
  FiscalRegimensResponse,
} from '@/data/api/model/fiscal/FiscalDto';
import { SellerFiscalDataResponse } from '@/data/api/model/sellers/SellersDto';
import { cfdiUsesResponseToSelectOptionsUi } from '@/hooks/fiscal/useGetCfdiUses/mapper';
import { fiscalRegimensResponseToSelectOptionsUi } from '@/hooks/fiscal/useGetFiscalRegimes/mapper';

export function sellerFiscalDataResponseToSellerFiscalDataUi(
  sellerFiscalDataResponse?: SellerFiscalDataResponse,
  fiscalRegimens?: FiscalRegimensResponse,
  cfdiUses?: CfdiUsesResponse
): SellerFiscalDataUi {
  return {
    rfc: sellerFiscalDataResponse?.tax_id ?? '',
    fiscalRegime: sellerFiscalDataResponse?.tax_regime_id ?? '',
    legalName: sellerFiscalDataResponse?.legal_name ?? '',
    cfdiUse: sellerFiscalDataResponse?.cfdi_use_id ?? '',
    postalCode: sellerFiscalDataResponse?.zip_code ?? '',
    taxEmail: sellerFiscalDataResponse?.email ?? '',
    cancelDisabled: true,
    saveDisabled: true,
    fiscalRegimeOptions:
      fiscalRegimensResponseToSelectOptionsUi(fiscalRegimens),
    cfdiUseOptions: cfdiUsesResponseToSelectOptionsUi(cfdiUses),
  };
}
